import { makeTxnPage } from "./Advances";
export default makeTxnPage({ title: "Bad Debt", endpoint: "/bad-debts", hasMonth: false, kindLabel: "Bad Debt" });
